/* eslint-disable  */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import InputMask from 'react-input-mask';

/**
 * Style.
 */
import './textfield.scss';

const Textfield = ({
  white,
  label,
  mask,
  input,
  meta,
  onlyNumbers,
  ...field
}) => {
  return (
    <div className="textfield-wrapper">
      <div className={classNames('textfield-label', { white })}>{label}</div>
      {mask ? (
        <div>
          <InputMask
            mask={mask}
            maskChar=""
            className={classNames('textfield-input', {
              'has-error': meta.touched && meta.error,
            })}
            type="text"
            {...field}
            {...input}
          />
          {meta.touched && meta.error && (
            <div>
              <span className="error-span">{meta.error}</span>
            </div>
          )}
        </div>
      ) : (
        <div>
          <input
            className={classNames('textfield-input', {
              'has-error': meta.touched && meta.error,
            })}
            type="text"
            {...field}
            {...input}
            onChange={(e) => {
              if (onlyNumbers) {
                const value =  e.target.value                
                if (value === '' || value.length === 1 && /[+]/.test(value) || /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g.test(value)) {
                  return input.onChange(e);
                } else {
                  return e.preventDefault();
                }
              } else {
                return input.onChange(e);
              }
            }}
          />
          {meta.touched && meta.error && (
            <div>
              <span className="error-span">{meta.error}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

Textfield.propTypes = {
  label: PropTypes.string.isRequired,
  input: PropTypes.object.isRequired,
  white: PropTypes.bool,
  mask: PropTypes.any,
  meta: PropTypes.object,
};

Textfield.defaultProps = {
  white: false,
  mask: null,
  meta: {},
};

export default Textfield;
